import styled, { css } from 'styled-components';

import { withGridCSS, WithGridProps } from 'app/shared/components/styleUtils';

/**
 * TODO (but not relevant for now)
 * - Auto-stretch columns to fit when no width is given
 */

interface ColProps {
  xs?: number;
  sm?: number;
  md?: number;
  lg?: number;
  xl?: number;
  xsStart?: number;
  smStart?: number;
  mdStart?: number;
  lgStart?: number;
  xlStart?: number;
  rowSpan?: number;
  row?: number;
}

export const Col = styled.div<ColProps>`
  ${({
    theme,
    xs,
    sm,
    md,
    lg,
    xl,
    xsStart,
    smStart,
    mdStart,
    lgStart,
    xlStart,
    rowSpan,
    row,
  }) => css`
    grid-column-end: span ${xs || 12};
    grid-column-start: ${xsStart || 'auto'};
    grid-row: span auto;

    ${
      rowSpan &&
      !row &&
      css`
        grid-row: span ${rowSpan};
      `
    }

    ${
      row &&
      !rowSpan &&
      css`
        grid-row: ${row};
      `
    }

    ${
      sm &&
      theme.media.sm`
      grid-column-start: ${smStart || 'auto'};
      grid-column-end: span ${sm};
    `
    }

    ${
      md &&
      theme.media.md`
      grid-column-start: ${mdStart || 'auto'};
      grid-column-end: span ${md};
    `
    }

    ${
      lg &&
      theme.media.lg`
      grid-column-start: ${lgStart || 'auto'};
      grid-column-end: span ${lg};
    `
    }

    ${
      xl &&
      theme.media.xl`
      grid-column-start: ${xlStart || 'auto'};
      grid-column-end: span ${xl};
    `
    }
  `}
`;

interface GridProps extends Omit<WithGridProps, 'numberOfColumns'> {
  cols?: number;
  maxWidth?: string;
}

export const Grid = styled.div<GridProps>`
  ${({
    cols = 12,
    gap = ['15px', '30px', '30px', '30px', '30px'],
    maxWidth,
    ...props
  }) => css`
    ${withGridCSS({ numberOfColumns: cols, gap, ...props })};
    ${maxWidth && `max-width: ${maxWidth};`}
  `}
`;
